module.exports = __webpack_public_path__ + "img/pr-8.139027c3.png";